<template>
  <vue-recaptcha
    ref="vue_recaptcha"
    v-if="!hidden"
    v-bind="rProps"
    v-on="$listeners"
    :sitekey="sitekey"
    :loadRecaptchaScript="loadRecaptchaScript"
    :class="scopedClass"
    @verify="updateToken"
    @expired="clearToken"
  />
</template>

<script>
import Util from '@/components/Util.js'
import VueRecaptcha from '../../utils/recaptcha/index.js'
export default {
  components: {
    VueRecaptcha
  },
  props: {
    loadRecaptchaScript: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    },
    sitekey: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    }
  },
  computed: {
    rProps() {
      // Devemos eliminar as props que são relacionadas à ou já definidas nesse componente
      var _keys = ['class', 'loadRecaptchaScript', 'hidden', 'sitekey']
      return Util.filterProps(this, _keys)
    },
    scopedClass() {
      var mb = this.$vuetify.breakpoint.xs ? 'mb-4' : 'mb-6'
      return `recaptcha mt-2 ${mb}`
    }
  },
  methods: {
    updateToken(response) {
      this.$emit('input', response)
    },
    clearToken() {
      this.$emit('input', '')
    },
    reset() {
      this.$refs.vue_recaptcha && this.$refs.vue_recaptcha.reset()
    },
    execute() {
      this.$refs.vue_recaptcha && this.$refs.vue_recaptcha.execute()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.recaptcha > div {
  width: 115% !important;
  right: 150px;
}
</style>
